<template>
    <footer class="main-footer bg-dark text-white pb-2">
        <div class="main-footer__map col-12 p-0 pb-2 d-none d-md-block">
            <div ref="map" style="min-height: 25vh;">
            </div>
        </div>
        <div class="container">
            <div class="main-footer__content text-center-xs row">
                <div class="col-md-4">
                    <p>
                        <strong>{{ name }}</strong><br />
                        <span v-html="address"></span><br />
                        <a :href="`tel:${phone}`" data-ga-track data-ga-category="Phone" data-ga-action="call" :data-ga-label="phone">{{ phone }}</a><br />
                        <a :href="`mailto:${email}`" data-ga-track data-ga-category="E-Mail" data-ga-action="click" :data-ga-label="email">{{ email }}</a>
                    </p>

                    <p>
                        <a href="https://www.facebook.com/Custom-Architectural-Stone-515268391966681/" target="_blank" data-ga-track data-ga-category="Facebook" data-ga-action="click">
                            <svg width="25px" height="25px" aria-hidden="true" data-prefix="fab" data-icon="facebook-square" class="svg-inline--fa fa-facebook-square fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M448 80v352c0 26.5-21.5 48-48 48h-85.3V302.8h60.6l8.7-67.6h-69.3V192c0-19.6 5.4-32.9 33.5-32.9H384V98.7c-6.2-.8-27.4-2.7-52.2-2.7-51.6 0-87 31.5-87 89.4v49.9H184v67.6h60.9V480H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48z"></path></svg>
                        </a>
                        <a href="https://www.instagram.com/customarchitecturalstone/" target="_blank" data-ga-track data-ga-category="Instagram" data-ga-action="click">
                            <svg width="25px" height="25px" aria-hidden="true" data-prefix="fab" data-icon="instagram" class="svg-inline--fa fa-instagram fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"></path></svg>
                        </a>
                    </p>
                </div>
                <div class="col-md-4">
                    <nav>
                        <menu-component name="footer" list-class="main-footer__list"></menu-component>
                    </nav>
                </div>
                <div class="col-md-4">
                    Copyright &copy; {{ (new Date()).getFullYear() }} - Powered by <a href="https://racerfish.com" target="blank">Racerfish</a>
                </div>
            </div>
        </div>
    </footer>
</template>
<script>
import Menu from '#app#/components/package/RF/CMS/Menu.vue';
import BaseLocator from '#app#/components/package/RF/Locator/BaseLocator.vue';
export default {
    data() {
        return {
            name: 'Custom Architectural Stone, Inc.',
            address: '1130 Mission Drive, Suite #102<br>Solvang, CA 93463',
            phone: '805-688-2628',
            email: 'infocustomarchstone@gmail.com'
        }
    },
    components: {
        'menu-component': Menu,
    },
    extends: BaseLocator
}
</script>



// WEBPACK FOOTER //
// js/components/common/Footer.vue